module.exports = __webpack_public_path__ + "static/img/regCode-3.2015208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/regCode-3.png
// module id = xRfx
// module chunks = 1